export const environment = {
  production: false,
  LoginURL: 'https://stage.glamera.com/login/GSPV1',
  saasURL: 'https://stage.glamera.com',
  apiURL:'https://api-stage.glamera.com/api/v5/b2c/rl',
  apiUrl: 'https://api-stage-new.glamera.com/api',
  RootDomain: 'glamera.com',
}
